export default {"src":"/_next/static/media/hand-emojji.82c4e269.svg","height":36,"width":36,"blurWidth":0,"blurHeight":0};